export default [{
  path: '/stage/orderSettlement',
  name: 'stage-orderSettlement',
  title: '订单结算',
  component: () => import('@/views/stage/template/orderSettlement/index')
}];
